import { print } from 'graphql';
import gql from 'graphql-tag';
import type { RxCollection, RxDocument, RxJsonSchema } from 'rxdb';

import { rootStore } from '../../mobx-models/Root';
import { BaseEntity } from '../../models/BaseEntity';
import { SYNC_LIMIT_LOW } from '../../utilities/constants';
import defaultDoc from '../Shared/defaultDoc';

export interface Block extends BaseEntity {
  readonly id: string;
  readonly description: string;
  readonly isActive: boolean;
}
export type BlockCollection = RxCollection<Block> | null;
export type BlockDocument = RxDocument<Block>;

export const blockSchema: RxJsonSchema<Block> = {
  type: 'object',
  version: 0,
  description: 'describes a Block object',
  primaryKey: 'id',
  properties: {
    id: { type: 'string', maxLength: 36 },
    description: { type: 'string' },
    updatedAt: { type: 'number' },
    isActive: { type: 'boolean' },
    isDeleted: { type: 'boolean' },
    version: { type: 'number' },
  },
};

export const blocksPullQueryBuilder = (doc: Block) => {
  if (!doc) {
    doc = { ...defaultDoc, updatedAt: 0 };
  }

  const query = print(gql`
    query blockFeed($siteId: ID!, $lastUpdateAt: Float!, $limit: Int!) {
      blockFeed(siteId: $siteId, lastUpdateAt: $lastUpdateAt, limit: $limit) {
        id
        description
        isActive
        isDeleted
        updatedAt
        version
      }
    }
  `);

  return {
    query,
    variables: {
      siteId: rootStore.user.siteId,
      lastUpdateAt: doc.updatedAt,
      limit: SYNC_LIMIT_LOW,
    },
  };
};

export default {};
